import { render, staticRenderFns } from "./AccountResumeList.vue?vue&type=template&id=721c39ce"
import script from "./AccountResumeList.vue?vue&type=script&lang=js"
export * from "./AccountResumeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports